export default "__VITE_ASSET__ce7f9e33__"